/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Box, Stack, Heading, Divider } from '@towersystems/towersystems-design-system';
import page from 'page';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import { requestConnection } from 'state/connections/actions';
import Navigation from 'modules/dashboard/connections/navigation';
import Button from 'components/button';
import ButtonGroup from 'components/button-group';
import OperationsList from './operations-list';
import cecSdk from 'lib/customer-ec-sdk';
import { errorNotice, successNotice } from 'state/notices/actions';

const Operations = ({ connectionId, ...props }) => {
    const [reload, setReload] = useState(false);

    const createFullOperation = async () => {
        try {
            setReload(false);
            await cecSdk
                .connection(connectionId)
                .forceCreateSyncOperation()
                .then((connection) => {
                    props.successNotice('Sync added to queue.');
                });
        } catch (error) {
            props.errorNotice('Failed to create operation, please try again.');
        }
        setReload(true);
    };

    return (
        <Main>
            <Navigation connectionId={connectionId} section='syncs' />
            <Box paddingTop='xxlarge' paddingBottom='xxlarge'>
                <Box display='flex' justifyContent='spaceBetween' alignItems='center' paddingBottom='xlarge'>
                    <Heading level='1'>Syncs</Heading>
                    <ButtonGroup>
                        <Button onClick={createFullOperation}>Create full sync</Button>
                    </ButtonGroup>
                </Box>
                <Divider />
            </Box>
            <Stack space='medium'>
                <OperationsList reload={reload} connectionId={connectionId} />
            </Stack>
        </Main>
    );
};

export default connect((state) => ({}), {
    requestConnection,
    errorNotice,
    successNotice,
})(Operations);
